import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useAHAB } from '@/contexts/AHABProvider';
import find from 'lodash/find';
import createClearRenderView from '@/utils/createClearRenderView';

const renderCleanValue = createClearRenderView();

export const MunicipalityUserView = (pk) => {
  const { isLoadingMunicipalities, municipalities } = useAHAB();
  const currentValue = useMemo(() => {
    if (!isLoadingMunicipalities) {
      return renderCleanValue(find(municipalities, { 'pk': Number(pk) })?.municipio);
    }
  }, [isLoadingMunicipalities, municipalities, pk]);
  
  return (
    <div className={'w-full'}>
      {currentValue}
    </div>
  );
};

MunicipalityUserView.propTypes = {
  pk: PropTypes.any
};

